import React from "react";
import { AxiosError } from "axios";
import * as R from "ramda";

import Forbidden from "components/Forbidden";
import { isForbiddenError } from "services/ocClient";

export class NetworkErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  async componentDidCatch(error, { componentStack }) {
    if (!(error instanceof AxiosError)) return; // This only cares about AxiosErrors
    const errorOwnProps = R.omit(["message", "stack"], error);
    console.error("NetworkErrorBoundary.didCatch", error, { errorOwnProps }, componentStack);
  }

  render() {
    const { children } = this.props;
    const { hasError, error } = this.state;
    if (hasError && isForbiddenError(error)) return <Forbidden />;
    // if (isNotFoundError(error)) return <NotFound />;
    // else let the higher ErrorBoundary handle it.
    return children;
  }
}
